module.exports = __webpack_public_path__ + "static/media/DMSans-Bold.91fedd82.woff2";